import { render, staticRenderFns } from "./CBuyerAndBookingRef.vue?vue&type=template&id=44e45c24&scoped=true&"
import script from "./CBuyerAndBookingRef.vue?vue&type=script&lang=js&"
export * from "./CBuyerAndBookingRef.vue?vue&type=script&lang=js&"
import style0 from "./CBuyerAndBookingRef.vue?vue&type=style&index=0&id=44e45c24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e45c24",
  null
  
)

export default component.exports